import Api from './api'
import utils = require('./model/utils');

type TEvent = {
    id: number,
    sessionId: string,
    time: string,
    event: string,
    data: any,
};

export default class EventReporter {

    api: Api;
    pendingEvents: TEvent[] = [];
    nextId: number = 1;
    sessionId = utils.guid4();
    loop: number;

    private lastReportedEvent?: TEvent;

    constructor(api: Api){
        this.api = api;
        //m.deferred.onerror = (e) => {
            // TODO reportError
            // console.error("Err", e);
        //};

        window.onerror = (message: any, url?: string, lineNumber?: number, column?: number, errorObj?) => {
            this.reportJsError({
                message: message,
                url: url,
                lineNumber: lineNumber,
                column: column,
                stackTrace: errorObj
            });
        };

        this.api.on('requestError', (data :any) =>
            this.reportServerRequestFailed(data));

        this.loop = window.setInterval(() =>
            this.sendPending(), 20000);
    }

    sendPending(){
        if(this.pendingEvents.length > 0){
            this.api.saveEvents(this.pendingEvents).then(
                () => this.pendingEvents = [],
                () => console.warn('Events log failed. Try it again later.')
            );
        }
    }

    report(eventType :string, data :any): EventReporter {

        if (process.env.NODE_ENV === 'development') {
            console.log('REPORT: '+eventType, data);
        }

        data = this.cleanupDataBeforeReport(data, eventType);

        const event: TEvent =  {
            id: this.nextId,
            sessionId: this.sessionId,
            time: utils.timestamp(),
            event: eventType,
            data: data,
        };

        this.pendingEvents.push(event);
        this.lastReportedEvent = event;

        this.nextId++ ;

        return this;
    }

    /**
     * Prevent data from grow to node_modules size
     */
    private cleanupDataBeforeReport<T extends {body?: any}>(data: T, eventType: string): T {
        // Prevent recursion, when data includes previous request data.events
        if (data?.body?.events) {
            data.body.events = "***RECURSION***";
        }

        // Prevent repetition of data when server failed several times in row
        if (eventType === "SERVER_REQUEST_FAILED" && this.lastReportedEvent?.event === "SERVER_REQUEST_FAILED") {
            data.body = "***TRUNCATED***";
        }

        return data;
    }

    reportFormShown(data :any){
        this.report("FORM_SHOWN" ,data);
    }
    reportFormAnswered(data :any){
        this.report("FORM_ANSWERED" ,data);
    }
    reportJsError(data :any){
        this.report("JS_ERROR" ,data);
        this.sendPending();
    }

    reportServerRequestFailed(data :any){
        this.report("SERVER_REQUEST_FAILED" ,data);
    }

    // TODO:
    reportQuestionaryDefinitionError(data :any){ this.report("QUESTIONARY_DEFINITION_ERROR" ,data); }

    // ??
    reportServerConnectionLost(data :any){ this.report("SERVER_CONNECTION_LOST" ,data); }
    reportServerConnectionRestored(data :any){ this.report("SERVER_CONNECTION_RESTORED" ,data); }
    reportImageBlockedByClient(data :any){ this.report("IMAGE_BLOCKED_BY_CLIENT" ,data); }
}
